const GENERIC_MESSAGE =
    "Operation Blocked — Receivables are frozen for this client.";

const OPERATION_MESSAGES: Record<string, string> = {
    cash_application:
        "Cash Application Blocked — Receivables are frozen for this client. This action has been logged.",
    purchase_create:
        "Purchase Entry Blocked — Cannot create or edit purchases while receivables are frozen.",
    purchase_repurchase:
        "Purchase Entry Blocked — Cannot create or edit purchases while receivables are frozen.",
    purchase_mark_failed:
        "Purchase Entry Blocked — Cannot create or edit purchases while receivables are frozen.",
    obligation_create:
        "Obligation Entry Blocked — Cannot create line items while receivables are frozen.",
    obligation_update:
        "Obligation Edit Blocked — Cannot edit line items while receivables are frozen.",
    obligation_delete:
        "Obligation Edit Blocked — Cannot delete line items while receivables are frozen.",
    cb_entry:
        "Chargeback Blocked — Cannot apply chargebacks while receivables are frozen.",
    cb_from_reserve:
        "Chargeback Blocked — Cannot apply chargebacks while receivables are frozen.",
    gb_entry:
        "Give-back Blocked — Cannot apply give-backs while receivables are frozen.",
    gb_from_reserve:
        "Give-back Blocked — Cannot apply give-backs while receivables are frozen.",
    receivable_add_payment:
        "Cash Application Blocked — Receivables are frozen for this client.",
    funding_request_update:
        "Funding Request Edit Blocked — Cannot edit funding requests while receivables are frozen.",
};

const getFreezeBlockedMessage = (operation?: string | null): string => {
    if (!operation) {
        return GENERIC_MESSAGE;
    }
    return OPERATION_MESSAGES[operation] || GENERIC_MESSAGE;
};

export default getFreezeBlockedMessage;
